import api from "~/store/api"

export const login = (data) => {
  return api.post("/users/auth", data).then((res) => {
    api.defaults.headers.common["Authorization"] = res.data.token
    return res.data
  })
}
